export const SizeRate: Record<number, string> = {
  1: '작아요',
  2: '잘 맞아요',
  3: '커요',
};

export const ColorRate: Record<number, string> = {
  1: '어두워요',
  2: '화면과 같아요',
  3: '밝아요',
};
